import { BaseSlackBuilder } from '@nu-art/slack-shared';
import { ModuleFE_Slack } from './ModuleFE_Slack.js';
/**
 * FE implementation of slack message builder
 */
export class SlackBuilderFE extends BaseSlackBuilder {
    constructor(channel) {
        super(channel);
    }
    send = async () => {
        await ModuleFE_Slack.vv1.sendFEMessage({
            channel: this.channel,
            messageBlocks: this.blocks,
            messageReplies: this.replies,
        }).executeSync();
    };
    sendMessage = undefined;
    sendFiles = undefined;
    sendReplies = undefined;
}
//# sourceMappingURL=SlackBuilderFE.js.map